import { FormControl, InputLabel, Select, MenuItem, Button } from "@material-ui/core"
import { useEffect } from "react"
import { useState } from "react"
import { useDispatch } from "react-redux"
import { cambiarEstatusPaqueteAction } from "../../../ducks/paqueteDuck"
import useCatalogo from "./../../../hooks/useCatalogos"
import { ToastMessage } from "../../../global/ToastMessage"
import BackDrop from "../../../global/BackDrop"
const FormularioEstatusPaquete = (props) => {
    const { clavePaquete = "", idEstatusPaquete = 1, AdministradoDooddo = false } = props
    const catalogo = useCatalogo("StatusPackage")
    const [estatus, setEstatus] = useState(0)
    const dispatch = useDispatch()
    const [load, setLoad] = useState(false)
    const handleSelect = (event) => {
        setEstatus(event.target.value)
    }
    const onGuardar = () => {
        setLoad(true)
        dispatch(cambiarEstatusPaqueteAction({ ClavePaquete: clavePaquete, idEstatusPaquete: estatus, AdministradoDooddo })).then(Response => {
            setLoad(false)
            if (Response.status === 500) {
                ToastMessage.fire({
                    icon: "error",
                    title: "Ocurrio un problema al actulizar el paquete",
                })
                return null
            }
            if (Response.status === 400) {
                ToastMessage.fire({
                    icon: "error",
                    title: Response.Message,
                })
                return null
            }
            ToastMessage.fire({
                icon: "success",
                title: "Ingreso Correcto",
            })
        })
    }

    useEffect(() => {
        setEstatus(idEstatusPaquete)
    }, [idEstatusPaquete])

    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
            <FormControl
                variant="outlined"
                style={{ width: "100%", margin: "5px" }}
            >
                <InputLabel id="lTEstatus">Estatus</InputLabel>
                <Select
                    labelId="lTEstatus"
                    id="sEstatus"
                    name="estatus"
                    value={estatus}
                    onChange={handleSelect}
                    label="Estatus"
                >
                    <MenuItem value="" disabled>
                        {"Seleccione una opción"}
                    </MenuItem>
                    {catalogo.map((item, index) => (
                        <MenuItem key={item.IdCatEstatusPaquete} value={item.IdCatEstatusPaquete}>
                            {`${item.Descripcion}`}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <Button
                onClick={onGuardar}
                color="primary"
                variant="text"
            >
                Aplicar
            </Button>
            <BackDrop open={load} />
        </div>
    )
}
export default FormularioEstatusPaquete